.widgetWrapper {
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  pointer-events: auto;
  background: var(--color-cool-gray);
  border-radius: var(--border-radius-large);
  /* box-shadow: var(--box-shadow); */
  

  @media (--lg) {
    width: 624px;
    margin-left: auto;
    margin-right: initial;
    &.fullHeight {
      height: 100vh;
      width: 842px;
      border-radius: 0;
      background-color: white;
    }
    &.narrow {
      width:490px;
      padding-bottom: 70px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      & > div:first-child {
        overflow-y: auto;
      }
    }
    &.fullscreen {
      display: flex;
      flex-direction: row-reverse;
      height: 100vh;
      width: 842px;
      border-radius: 0;
      & > div {
        width: 50%;
        overflow-y: auto;
      }
      
      & .contentBottom {
        padding: var(--padding);
        display: flex;
        flex-direction: column;
        width: 50%;
        overflow-y: auto;
        padding-bottom: 65px;
      }
      & .contentBottom {
        &.contentOptions {
         width: 100%;
         padding:0;
        }
        &.noPadding {
          padding:0;
        }
      }
    }
  }

  &.isLoading {
    pointer-events: none;
  }

  

  &.tabsLeft {
    border-top-left-radius: 0;
  }
}

.content, .contentBottom {
  display: grid;
  grid-template-columns: 1fr;

  @media (--lg) {

    /*grid-template-columns: 1fr;
    grid-template-rows: 1fr min-content;*/
    /*grid-template-columns: 1fr 1fr;*/
  }
}

.group {
  display: grid;
  grid-template-rows: max-content;
  align-content: start;
  gap: inherit;
  width: 100%;
}

.content {
  gap: calc(var(--spacing) * 2);
}

.contentFull > div.group::after {
  content:'';
  margin-left: calc(var(--padding) * -1);
  width: calc(100% + (var(--padding) * 2));
  background-color: rgb(222, 221, 221);
  inline-size: calc(100% + (var(--padding) * 2));
  block-size: 1px;
  inset-inline-start: 0;
  inset-block-start: calc(var(--spacing) * -1);
}

.contentFull > div.group:last-child:after {
  content:none;
}

.contentBottom {
  gap: var(--spacing);
  padding: var(--padding-small);
  background: white;

  &.noBackground {
    background: none;
  }

  &.largePadding {
    padding: var(--padding);
    gap: calc(var(--spacing) * 2);
  }

  &.noPadding {
    padding:0;
  }
}

.bottomButton {
  margin-top: auto;
  @media (--lg) {
    margin-left: -15px;
    width: calc(100% + 30px);
  }
}

.fullWidth {
  grid-column: 1 / -1;
}


.fieldDescription {
  display: flex;
  height: 56px;
  align-items: center;
}

.capitalize::first-letter {
  text-transform: capitalize;
}

.bold {
  font-weight: 500;
}

.label {
  position: relative;
  font-size: 13px;
  text-transform: uppercase;

  &.gray {
    color: var(--color-black-50);
  }
}

.title {
  font-size: 14px;
  font-weight: 500;
  margin-top: 5px;
}
.titleLarge {
  font-size: 20px;
  font-weight: 500;
  margin-top: 5px;
  &>s {
    color: rgba(0, 0, 0, 0.8);
    font-weight: 400;
  }
}

.subtitle {
  font-size: 13px;
  line-height: 16px;
  color: var(--color-black-50);
  margin-top: 2px;
  &.warning {
    color:#DA0A2B;
  }
}

.smaller {
  font-size: 13px;
}

.linkButton {
  text-decoration: underline;
}

.option {
  color: black;
  background: var(--color-yellow);
  font-size: 11px;
  line-height: 12px;
  border-radius: var(--border-radius);
  padding: 4px 6px;
}

.icon {
  width: 44px;
}

.hidden {
  display: none;
}